
export default {
  data () {
    return {
      hours: [8, 24],
      now: new Date().getHours(),
      interval: null,
      time: null
    }
  },
  props: {
    showchat: { type: Boolean, default: true }
  },
  computed: {
    currentTime () {
      return this.now > this.hours[0] && this.now < this.hours[1]
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  created () {
    if (process.browser) {
      this.interval = setInterval(() => {
        this.time = Intl.DateTimeFormat(navigator.language, {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        }).format()
      }, 1000)
    }
  }
}
